'use client';

import { Trans, t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { Logout } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { Theme } from '@prismo-io/design-system';
import { useSignOut } from '@prismo-io/feature-auth';
import { Application, translate } from '@prismo-io/router';
import { LanguageCode, type LanguageCodeT } from '@prismo-io/schemas';
import { useRouter } from 'next/navigation';
import { type FC, useState } from 'react';
const buildSuccessUrl = (locale: LanguageCodeT) => {
  // eslint-disable-next-line no-constant-condition, prettier/prettier
  return translate({
    app: Application.APP,
    path: `/`,
    locale
  });
};
export const SignOut: FC = () => {
  const [signOutDialog, setSignOutDialog] = useState<boolean>(false);
  const {
    i18n
  } = useLingui();
  const {
    locale = LanguageCode.Enum.fr
  } = i18n;
  const successUrl = buildSuccessUrl(locale as LanguageCodeT);
  const router = useRouter();
  const {
    trigger: signOut
  } = useSignOut();
  const onConfirmSignOut = () => {
    setSignOutDialog(false);
    signOut(undefined, {
      onSuccess() {
        router.push(successUrl);
      }
    });
  };
  const theme = useTheme<Theme>();
  return <>
      <Tooltip title={t`Déconnexion`} placement="top" data-sentry-element="Tooltip" data-sentry-source-file="sign-out.tsx">
        <IconButton onClick={() => setSignOutDialog(true)} data-sentry-element="IconButton" data-sentry-source-file="sign-out.tsx">
          <Logout sx={{
          color: theme.palette.error.light
        }} data-sentry-element="Logout" data-sentry-source-file="sign-out.tsx" />
        </IconButton>
      </Tooltip>
      <Dialog open={signOutDialog} onClose={() => setSignOutDialog(false)} maxWidth="md" data-sentry-element="Dialog" data-sentry-source-file="sign-out.tsx">
        <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="sign-out.tsx">
          <Typography variant="h2" textAlign="center" data-sentry-element="Typography" data-sentry-source-file="sign-out.tsx">
            <Trans data-sentry-element="Trans" data-sentry-source-file="sign-out.tsx">Déconnexion</Trans>
          </Typography>
        </DialogTitle>
        <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="sign-out.tsx">
          <Typography textAlign="center" data-sentry-element="Typography" data-sentry-source-file="sign-out.tsx">
            <Trans data-sentry-element="Trans" data-sentry-source-file="sign-out.tsx">Souhaitez-vous vraiment vous déconnecter ?</Trans>
          </Typography>
        </DialogContent>
        <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="sign-out.tsx">
          <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%" data-sentry-element="Stack" data-sentry-source-file="sign-out.tsx">
            <Button variant="text" color="gray" onClick={() => setSignOutDialog(false)} data-sentry-element="Button" data-sentry-source-file="sign-out.tsx">
              <Trans data-sentry-element="Trans" data-sentry-source-file="sign-out.tsx">Non</Trans>
            </Button>
            <Button variant="contained" color="error" onClick={onConfirmSignOut} data-sentry-element="Button" data-sentry-source-file="sign-out.tsx">
              <Trans data-sentry-element="Trans" data-sentry-source-file="sign-out.tsx">Oui</Trans>
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
    </>;
};